import { render, staticRenderFns } from "./EnigmaSuggestion.vue?vue&type=template&id=2a7fb456&scoped=true&"
import script from "./EnigmaSuggestion.vue?vue&type=script&lang=js&"
export * from "./EnigmaSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./EnigmaSuggestion.vue?vue&type=style&index=0&id=2a7fb456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7fb456",
  null
  
)

export default component.exports